import { render, staticRenderFns } from "./brandProtocol.vue?vue&type=template&id=04fd8e42&scoped=true"
import script from "./brandProtocol.vue?vue&type=script&lang=js"
export * from "./brandProtocol.vue?vue&type=script&lang=js"
import style0 from "./brandProtocol.vue?vue&type=style&index=0&id=04fd8e42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd8e42",
  null
  
)

export default component.exports